import { Box, Checkbox, FormControlLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom'
import { T, TF } from "react-translator-component";
import GCBackButton from '../../../components/GreenCity/GCBackButton'
import { styles } from '../../styles';
import profile from "../../../assets/images/profile_img.png";
import Separator from '../../../components/Separator';
import { colors } from '../../../common/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import ButtonPrimary from '../../../components/ButtonPrimary';
import SubmitButton from '../../../components/SubmitButton';
import SeclectGroup from '../../../components/GreenCity/SeclectGroup';
import MessageModal from '../../../components/Models/GreenCity/MessageModal';
import { ErrorMessageModal } from '../../../components/ErrorMessageModal';
import appServices from '../../../services/app-services/appServices';
import { convertUserImage } from '../../../util/utils';

function GroupPayment(){
  const defaultImage = require("../../../assets/images/default.png")

  const location = useLocation();
  const { groupInfo } = location.state || {}; // Destructure your props
  const navigate = useNavigate();
  const { user } = useSelector((state: any) => state.userAuth);
  const [agree1, setAgree1] = useState<boolean>(false);
  const [agree2, setAgree2] = useState<boolean>(false);
  const [agree3, setAgree3] = useState<boolean>(false);
  const [feeType, setFeeType] = useState<string>('other_fee');
  const [amount, setAmount] = useState<number | null>(null)
  const [paymentDescription, setPaymentDescription] = useState<string>('')
  const [groupError, setGroupError] = useState<string>('')
  const [amountError, setAmountError] = useState<string>('')
  const [showMessageModalBtn, setShowMessageModalBtn] = useState<boolean>(false);
  const [showGroups, setShowGroups] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('')
  const [openMessageModal, setOpenMessageModal] = useState<boolean>(false)
  const [openErrorMessageModal, setOpenErrorMessageModal] = useState<boolean>(false)
  const [accountInfo, setAccountInfo] = useState<any>();
  const [selectedGroup, setGroup] = useState<any>();
  const [selectedGroupIcon, setSelectedGroupIcon] = useState<any>(defaultImage);
  const [isAlreadyPaid, setIsAlreadyPaid] = useState<boolean>(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  // マイページ「グループ」セクション
  // 支払い保留中のグループを押下したときにgroupInfoが渡されてくる
  useEffect(()=>{
    if(groupInfo?.id){
      setGroup(groupInfo);
      setFeeType('joining_fee')
      setAmount(groupInfo?.joining_fee_amount);
      setMessage(`${T("payment_required_to_join_group")}`)
      setShowMessageModalBtn(true);
      setOpenMessageModal(true);
    }
  },[groupInfo]);

  useEffect(()=>{
    if(!groupInfo?.id){
      setFeeType('other_fee')
    }

    if (selectedGroup?.id) {
      getIcon(selectedGroup)
    }

  },[selectedGroup])

  const getIcon = (groupInfo: any) => {
    const groupId = groupInfo?.id

    appServices.getGroupIcon(groupId).then(blob => {
      const file = new File([blob], groupInfo.group_icon, { type: blob.type });
      setSelectedGroupIcon(URL.createObjectURL(file));
    }).catch(() => {
      console.error("Failed to get group icon image")
      setSelectedGroupIcon(defaultImage);
    })
  }

  const getUserBalance=async ()=>{
    try {
      const res = await appServices.getUserBalance(user?.id);
      setAccountInfo(res?.wallet_information?.balance?.money?.amount);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(()=>{
    if (groupInfo?.id) return

    if (selectedGroup && (feeType === 'monthly' || feeType === 'yearly')) {
      setAmount(selectedGroup.fee_amount);
    } else {
      setAmount(null)
    }

    if (selectedGroup && (selectedGroup.fee_type === 'monthly' || selectedGroup.fee_type === 'yearly')) {
      getMembershipFeeStatus()
    }

  }, [selectedGroup, feeType]);

  const getMembershipFeeStatus = () => {
    if (!selectedGroup?.id || !selectedGroup?.fee_amount || selectedGroup?.fee_amount === 0) {
      setIsAlreadyPaid(false)
      return
    }

    appServices.getMembershipFeeStatus(selectedGroup.id, selectedGroup.fee_type).then(res => {
      setIsAlreadyPaid(res.is_already_paid)
    }).catch(error => {
      setIsAlreadyPaid(false)
      console.error(error)
    })
  }

  useEffect(()=>{
    getUserBalance();
  },[user])

  const handleValidate = async (): Promise<boolean> => {
    if(!selectedGroup?.id){
      setGroupError(`${T("group")}${T("error_select")}`);
      return false;
    }

    if(!amount){
      setAmountError(`${T("payment_amount")}${T("error_enter")}`);
      return false;
    }

    return true
  }

  const handleSubmit = async (): Promise<boolean> => {
    let payment_type=feeType==='monthly'||feeType==='yearly'?'membership_fee':feeType;
    let billing_cycle=payment_type==='membership_fee'?feeType:'one_time';
    let body={
      "payer_type": "User",
      "payer_id": user?.id,
      "payee_type": "MemberGroup",
      "payee_id": selectedGroup?.id,
      "payment_type": payment_type,
      "billing_cycle": billing_cycle,
      "amount": amount,
      "payment_details": paymentDescription,
    }

      try {
        const res = await appServices.createPayment(body);
        if (res?.success) {
          setMessage(
            groupInfo ?
              T('payment_paid_joining_fee'):
              T('payment_paid_to_group'));
          setOpenMessageModal(true)
          setTimeout(()=> navigate(-1), 3000);
          return true
        } else {
          setMessage(`${T('payment_other_error')}`);
          setOpenMessageModal(true)
        }
      } catch (error:any) {
        const errorResponse = error.response.data.message
        setMessage(
          typeof errorResponse === "object" ?
          errorResponse.join("\n") :
          errorResponse
        );
        setOpenErrorMessageModal(true)
      }
      return false
    };

  const handleChange=(e:any)=>{
    setFeeType(e?.target.value);
  }

  const paymentRadioGroup = useMemo(() => (
    <RadioGroup
      aria-labelledby="payment"
      value={feeType}
      name="fee"
      onChange={handleChange}
    >
      {groupInfo?.id && <FormControlLabel value="joining_fee" control={<Radio />} label={T("payment_joining_fee")} />}
      {!groupInfo?.id && (
        <div style={{display: 'flex'}}>
          <FormControlLabel
            value="monthly"
            disabled={(selectedGroup?.fee_type==='monthly' && isAlreadyPaid) || selectedGroup?.fee_type === 'yearly' || selectedGroup?.fee_amount === 0}
            control={<Radio />}
            label={T('monthly_fee')}
          />
          {(selectedGroup?.fee_type==='monthly' && isAlreadyPaid) && <Typography style={style.paymentNotice}>{T("payment_monthly_fee_is_already_paid")}</Typography>}
        </div>
      )}
      {!groupInfo?.id && (
        <div style={{display: 'flex'}}>
          <FormControlLabel
            value="yearly"
            disabled={(selectedGroup?.fee_type === 'yearly' && isAlreadyPaid) || selectedGroup?.fee_type === 'monthly' || selectedGroup?.fee_amount === 0}
            control={<Radio />}
            label={T('yearly_fee')}
          />
          {(selectedGroup?.fee_type==='yearly' && isAlreadyPaid) && <Typography style={style.paymentNotice}>{T("payment_yearly_fee_is_already_paid")}</Typography>}
        </div>
      )}
      {!groupInfo?.id && <FormControlLabel value="other_fee" control={<Radio />} label={T("other")} />}
    </RadioGroup>
  ), [feeType, groupInfo, selectedGroup, isAlreadyPaid]);

  const handleChangeAmount = (value: string) => {
    if (Number.isNaN(Number(value))) return
    setAmount(Number(value))

    if(Number(value) > 0) setAmountError('')
  }

  const handleSelectedGroup = (group: any) => {
    setGroup(group)
    setShowGroups(false)
    setGroupError('')
    setFeeType('other_fee')
  }

  const handleCloseMessageModal = () => {
    setShowMessageModalBtn(false)
    setOpenMessageModal(false)
  }

  return (
    <div style={style.container}>
      <GCBackButton onClick={() => navigate(-1)} />

      <MessageModal
        open={openMessageModal}
        message={message}
        onContinue={()=> handleCloseMessageModal()}
        onClose={()=> handleCloseMessageModal()}
        showButton={showMessageModalBtn}
        buttonText={T("next")}
        buttonStyles={style.messageModalButton}
      />

      <ErrorMessageModal
        messages={[message]}
        open={openErrorMessageModal}
        onClose={()=>{ setOpenErrorMessageModal(false) }}
        showButton
        alignLeft={message.indexOf("\n") !== -1}
      />

      <Box style={{ padding: 16 }}>
        <Typography style={{ fontWeight: "700" }}>
          <img src={user?.image ? convertUserImage(user.image) : profile}
            alt={"user_img"}
            style={{
              ...styles.farmProfileIcon,
              height: 50,
              width: 50,
              margin: 0,
            }}
          />
          &nbsp;  {user?.nickname || user?.name}
        </Typography>
      </Box>

      <div style={{backgroundColor:colors.farm_gray15}}>
        <Separator sx={{ marginTop: "10px",marginBottom: "10px" }} color="gray" />

        <Box  style={{ padding: 16 }}>
          <Typography>{T("payment_address")}</Typography>

          <Separator sx={{ marginTop: "2px" }} color={colors.farm_green200} />

          {!showGroups && selectedGroup?.id &&
            <Box style={style.marginTB}>
              <Typography style={{ fontWeight: "700" }}>
                <img
                  src={selectedGroupIcon}
                  alt={"img"}
                  style={{
                    ...styles.farmProfileIcon,
                    height: 40,
                    width: 40,
                    margin: 0,
                  }}
                />
                &nbsp;{selectedGroup?.name}
              </Typography>
            </Box>
          }

          {!groupInfo?.id && (
            showGroups ? (
              <SeclectGroup onNext={(group) => {handleSelectedGroup(group)}} />
            ) : (
              <>
                <ButtonPrimary title={T('select_group')} onClick={()=>{setShowGroups(true)}} />
                <Typography style={{color:'red'}}>{groupError}</Typography>
              </>
            )
          )}

          <br/>

          <Typography>{T("payment_type")}</Typography>
          <Separator sx={{ marginTop: "2px" }} color={colors.farm_green200} />

          {paymentRadioGroup}

          <Typography>{T("payment_amount")}</Typography>
          <Separator sx={{ marginTop: "2px" }} color={colors.farm_green200} />

          <br/>

          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'baseline'}}>
            <TextField
              disabled={groupInfo?.id || (feeType === 'monthly' || feeType === 'yearly')}
              placeholder='0'
              type='text'
              value={amount}
              onChange={(e) => handleChangeAmount(e.target.value)}
              sx={{ input: { textAlign: 'right' } }}
              id="outlined-basic"
              hiddenLabel
              variant="outlined"
            />
            {T("unit_yen")}
          </div>

          <Typography style={style.balance}>
            {TF(T("payment_balance"), accountInfo ?? "")}
          </Typography>

          {!showGroups && <Typography style={{color:'red'}}>{amountError}</Typography>}

          <br/>

          <Typography>{T("payment_details")}</Typography>
          <Separator sx={{ marginTop: "2px" }} color={colors.farm_green200} />

          <br>
          </br>

          <TextField
            value={paymentDescription}
            onChange={(e)=> setPaymentDescription(e.target.value)}
            multiline
            rows={2}
            hiddenLabel
            fullWidth
            variant="outlined"
          />

          <br/>
          <br/>

          <div style={{ padding: "15px 10px" }}>
            <Typography>{T("notice")}</Typography>
            <Separator sx={{ marginTop: "2px" }} color={colors.farm_green200} />

            <FormControlLabel
              control={<Checkbox checked={agree1} onChange={(e) => setAgree1(e.target.checked)} />}
              color="error"
              sx={{ color: false ? colors.farm_red600 : "black", marginTop: "30px" }}
              label={T('payment_checklist_1')}
            />

            <FormControlLabel
              control={<Checkbox checked={agree2} onChange={(e) => setAgree2(e.target.checked)} />}
              color="error"
              sx={{ color: false ? colors.farm_red600 : "black", marginTop: "20px" }}
              label={T('payment_checklist_2')}
            />

            <FormControlLabel
              control={<Checkbox checked={agree3} onChange={(e) => setAgree3(e.target.checked)} />}
              color="error"
              sx={{ color: false ? colors.farm_red600 : "black", marginTop: "20px" }}
              label={T('payment_checklist_3')}
            />
          </div>

          {/* Submit Button */}
          <SubmitButton
            disabled={!agree1 || !agree2 || !agree3}
            color="secondary"
            sx={style.submitButton}
            size={"large"}
            variant="outlined"
            endIcon={<FontAwesomeIcon style={{ position: "absolute", top: 0, right: 0, margin: "10px" }} icon={faChevronRight} />}
            validate={handleValidate}
            onSubmit={handleSubmit}
          >
            {!groupInfo?.id ? T("pay") : T("payment_transfer_money")}
          </SubmitButton>
        </Box>
      </div>
    </div>
  )
}

export default GroupPayment

const style = {
  container: {
    paddingTop: 90,
  },
  marginTB:{
    marginTop: "10px",
    marginBottom: "10px"
  },
  balance:{
    fontSize:12,
    color:colors.farm_gray200
  },
  submitButton: {
    width: "80%",
    alignSelf: "center",
    margin: "0 auto",
    display: "flex",
    borderRadius: 20,
    border: "2px solid",
    marginBottom:8
  },
  paymentNotice: {
    color: "red",
    display: "flex",
    alignItems: "center",
  },
  errorDialogButton: {
    width: "50%",
    minWitdh: "100px",
    alignSelf: "center",
    display: "flex",
    border: "3px solid",
    borderRadius: "10px",
    borderColor: colors.farm_blue200,
    color: colors.farm_black
  },
  messageModalButton: {
    color: colors.farm_blue200,
    border: "2px solid ",
    margin: "0px 30px",
    borderRadius: "10px",
    padding: "10px",
    width: "85%",
    maxWidth: 300,
  }
};
